import { Component, OnInit } from '@angular/core';
import { CurrentSessionService } from 'src/app/shared/services/current-session.service';
import { Report, TotalObject } from '../../report';
import { SettlementsService } from './settlements.service';

@Component({
  selector: 'app-settlements',
  templateUrl: './settlements.component.html',
  styleUrls: ['./settlements.component.scss']
})
export class SettlementsComponent implements OnInit {
  tableColumns: string[] = [
    'id',
    'merchant',
    'sales',
    'pending',
    'available',
    'totalBalance',
    'withdrawal',
    'fees'
  ];

  displayTableColumns = {
    'id':'Business Id',
    'merchant': 'Merchant',
    'sales': 'Sales',
    'pending': 'Pending',
    'available': 'Available',
    'totalBalance': 'Total Balance',
    'withdrawal': 'Total Withdrwal',
    'fees': 'Fees'

  };

  totalObject: TotalObject = {
    totalKeyColumn: 'merchant',
    columnsToGetTotalOf: [
      'sales',
      'pending',
      'available',
      'totalBalance',
      'withdrawal'
    ]
  };


  totalNumberOfRecords = 0;
  settlementReportData: any[] = [];
  isAssignedBusinessSelected: boolean = false;
  requestBody: Report = {};
  loading = false;

  constructor(public settlementReport: SettlementsService,
    private getCurrentSessionService: CurrentSessionService
  ) { }

  async ngOnInit() {
    this.settlementReport.activateLoader();

    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    await this.updateTable();

  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.settlementReport.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.settlementReport.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.settlementReport.loader().subscribe(val => (this.loading = val));
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = undefined;
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.settlementReport.loader().subscribe(val => (this.loading = val));
  }


  async updateTable() {
    this.settlementReport.activateLoader();
    if (this.isAssignedBusinessSelected){
      if(!this.requestBody['filterOptions']){
        this.requestBody['filterOptions'] = {}
      }
      const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
      this.requestBody['filterOptions']['adminId'] = adminId
    } else {
      delete this.requestBody?.filterOptions?.adminId
    }
    this.settlementReport.setParams(this.requestBody);
    const report = await this.settlementReport.make();
    this.settlementReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  assignedBusinessesFilterChanged(value){
    this.isAssignedBusinessSelected = value;
  }
}



